"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _Select = _interopRequireDefault(require("../../../select/Select"));
var _Age = _interopRequireDefault(require("./Age.style"));
var _Datepicker = _interopRequireDefault(require("../../../datepicker/Datepicker"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var lastDayOfTheYear = (0, _utils.getLastDayOfTheYear)();
// naming around this will be updated when we add a filtered variable list instead of Age
var Age = function Age(_ref) {
  var id = _ref.id,
    isFocused = _ref.isFocused,
    ageOptions = _ref.ageOptions,
    ageType = _ref.ageType,
    date = _ref.date,
    onChangeAgeType = _ref.onChangeAgeType,
    onChangeDate = _ref.onChangeDate,
    disabled = _ref.disabled;
  var datePicker;
  if (ageType === 'age-on-date' || ageType === 'age-on-date-prev') {
    datePicker = /*#__PURE__*/_react["default"].createElement(_Datepicker["default"], {
      disabled: disabled,
      id: "".concat(id, "Date"),
      className: "aod-datepicker",
      value: date,
      onChange: function onChange(changedDate) {
        return onChangeDate((0, _utils.offsetTimezone)(changedDate));
      },
      minDetail: "year",
      maxDetail: "month",
      maxDate: lastDayOfTheYear,
      showNavigation: false,
      view: "year",
      placeholder: "dd/mm",
      format: "dd/MM"
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_Age["default"], {
    isFocused: isFocused,
    "data-testid": "age-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    disabled: disabled,
    id: "".concat(id, "AgeType"),
    className: "age-select",
    onChange: onChangeAgeType,
    options: ageOptions,
    value: ageType,
    searchable: false
  }), date && datePicker);
};
Age.propTypes = {
  /** The html id for the datepicker */
  id: _propTypes["default"].string.isRequired,
  /** Flag to indicate if the component is selected */
  isFocused: _propTypes["default"].bool.isRequired,
  /** The option list for the age selector */
  ageOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  })),
  /** The selected option for age */
  ageType: _propTypes["default"].string,
  /** The value of the date in case an age with date is selected. */
  date: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  /** Action to call when changing the option from the age type select. */
  onChangeAgeType: _propTypes["default"].func.isRequired,
  /** Action to call when changing the date. */
  onChangeDate: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool
};
Age.defaultProps = {
  disabled: false,
  ageOptions: [{
    label: 'Age',
    value: 'age'
  }, {
    label: 'Age (date)',
    value: 'age-on-date'
  }],
  ageType: '',
  date: undefined
};
var _default = exports["default"] = Age;